import React from 'react'

import { B4 } from '@zet/design-system'
import { Alert } from '@zet/design-system/alert'

export const DemoSellAlert = ({ content }: { content: string }) => {
  return (
    <Alert intent="info">
      <B4 className="text-decorative-bee-150">{content}</B4>
    </Alert>
  )
}
